import React, { useState } from 'react'
import { DeleteModal } from './DeleteModal'

export interface DeleteMenuItemLabelProps {
    text: string
    confirmTitle?: string
    confirmDescription?: string
    okButtonText?: string
    onConfirm: () => void
}

export const DeleteMenuItemLabel: React.FC<DeleteMenuItemLabelProps> = ({
    text,
    confirmTitle,
    confirmDescription,
    okButtonText,
    onConfirm,
}) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
        setIsOpen(true)
    }

    return (
        <>
            <span onClick={handleClick}>{text}</span>
            <DeleteModal
                open={isOpen}
                title={confirmTitle}
                description={confirmDescription}
                okButtonText={okButtonText}
                onCancel={() => setIsOpen(false)}
                onConfirm={() => {
                    setIsOpen(false)
                    onConfirm()
                }}
            />
        </>
    )
}
